<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Полное наименование (буквами русского алфавита)"
          outlined
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          label="Регистрационный номер юридического лица в стране его регистрации"
          outlined
          v-model="v.regNumber.$model"
          :errorMessages="getValidationErrorText(v.regNumber)"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          v-mask="Mask.INN_ORG"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН (при наличии)"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

import {
  CYRILLIC_NUMBER_SYMBOL,
  EMOJI,
  getValidationErrorText,
  INN,
} from '@/utils/validate';
import { Mask } from '@/constants';

export const foreignOrganizationModel = {
  name: '',
  regNumber: '',
  inn: '',
};

export const foreignOrganizationValidation = {
  name: {
    required,
    CYRILLIC_NUMBER_SYMBOL,
    maxLength: maxLength(1000),
    EMOJI,
  },
  regNumber: {
    maxLength: maxLength(50),
    EMOJI,
  },
  inn: {
    maxLength: maxLength(10),
    EMOJI,
    INN: INN(10),
  },
};

export default {
  props: {
    v: Object,
  },
  data: () => ({
    Mask,
    getValidationErrorText,
  }),
};
</script>
